export const documentStatuses = Object.freeze({
  Draft: 1,
  SignatureSetupProcess: 2,
  SignaturePending: 3,
  Cancelled: 4,
  Signed: 5
});

export const documentStatusesString = Object.freeze({
  1: "Borrador",
  2: "En proceso de configuración",
  3: "Pendiente de Firma",
  4: "Cancelado",
  5: "Firmado"
});
